import { defineMessages, useIntl } from "react-intl";
import { IconExclamationCircle } from "@tabler/icons-react";
import { CheckoutError as CheckoutErrorModel } from "../../models/checkout";
import "./error.scss";

const transDefs = defineMessages({
  title: { id: "cart.booking-error.title", defaultMessage: "Réservation indisponible" },
  desc: { id: "cart.booking-error.desc", defaultMessage: "Nous ne sommes pas en mesure de traiter votre demande de réservation pour le moment." },
  overcrowded: { id: "cart.booking-error.overcrowded", defaultMessage: "Un maximum {max, plural, =1 {d'une personne peut} other {de # personnes peuvent}} séjourner dans cette location. " },
  overbooking: { id: "cart.booking-error.overbooking", defaultMessage: "Les dates sélectionnées peuvent être entrées en conflit avec des réservations existantes." },
  foot: { id: "cart.booking-error.footer", defaultMessage: "Veuillez adapter vos dates ou nous contacter afin de trouver des disponibilités appropriées." }
});

type Props = {
  maxGuests?: number;
  error: CheckoutErrorModel;
};

const CheckoutError = ({ maxGuests: max, error }: Props) => {

  const intl = useIntl();

  return (
    <section className="checkout-failure">
      <h2 className="header">
        <span className="iconized">
          <IconExclamationCircle />
        </span>
        {intl.formatMessage(transDefs.title)}
      </h2>
      <p>{intl.formatMessage(transDefs.desc)}</p>
      <ul>
        {(!!max && error === "overcrowded") &&
          <li>{intl.formatMessage(transDefs.overcrowded, { max })}</li>
        }
        <li>{intl.formatMessage(transDefs.overbooking)}</li>
      </ul>
      <p>{intl.formatMessage(transDefs.foot)}</p>
    </section>);

}

export default CheckoutError;
